<edit-form
  #editForm
  [resource]="entry"
  [inEditMode]="inEditMode"
  (onSaved)="signalModifiedEntry($event)">
  <div class="attributes-map">
    <ng-container *ngIf="showUserField && schema.user.writable">
      <div class="attributes-map--key"
           [ngClass]="{'-required': isRequired('user')}"
           [textContent]="schema.user.name">
      </div>
      <div class="attributes-map--value">
        <editable-attribute-field [resource]="entry"
                                  [wrapperClasses]="'-tiny'"
                                  [fieldName]="'user'">
        </editable-attribute-field>
      </div>
    </ng-container>

    <div class="attributes-map--key"
         [ngClass]="{'-required': isRequired('spentOn')}"
         [textContent]="schema.spentOn.name">
    </div>
    <div class="attributes-map--value">
      <editable-attribute-field [resource]="entry"
                                [wrapperClasses]="'-tiny'"
                                [fieldName]="'spentOn'">
      </editable-attribute-field>
    </div>

    <div class="attributes-map--key"
         [ngClass]="{'-required': isRequired('hours')}"
         [textContent]="schema.hours.name">
    </div>
    <div class="attributes-map--value">
      <editable-attribute-field [resource]="entry"
                                [wrapperClasses]="'-tiny'"
                                [fieldName]="'hours'">
      </editable-attribute-field>
    </div>

    <ng-container *ngIf="showWorkPackageField">
      <div class="attributes-map--key"
           [ngClass]="{'-required': isRequired('workPackage')}"
           [textContent]="schema.workPackage.name">
      </div>
      <div class="attributes-map--value">
        <editable-attribute-field [resource]="entry"
                                  [fieldName]="'workPackage'">
        </editable-attribute-field>
      </div>
    </ng-container>

    <div class="attributes-map--key"
         [ngClass]="{'-required': isRequired('activity')}"
         [textContent]="schema.activity.name">
    </div>
    <div class="attributes-map--value">
      <editable-attribute-field *ngIf="workPackageSelected"
                                [resource]="entry"
                                [fieldName]="'activity'">
      </editable-attribute-field>
      <i *ngIf="!workPackageSelected"
         [textContent]="text.wpRequired">
      </i>
    </div>

    <div class="attributes-map--key"
         [ngClass]="{'-required': isRequired('comment')}"
         [textContent]="schema.comment.name">
    </div>
    <div class="attributes-map--value">
      <editable-attribute-field [resource]="entry"
                                [fieldName]="'comment'">
      </editable-attribute-field>
    </div>

    <ng-container *ngFor="let cf of customFields">
      <div class="attributes-map--key"
           [ngClass]="{'-required': isRequired(cf.key)}"
           [textContent]="cf.label">
      </div>
      <div class="attributes-map--value">
        <editable-attribute-field [resource]="entry"
                                  [fieldName]="cf.key">
        </editable-attribute-field>
      </div>
    </ng-container>
  </div>
</edit-form>
